/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React from 'react';
import Layout from './Layout';
import { HeroSmp } from './HeroSections';
import { SmpOverview } from './PageSections';
import Clients from './Clients';
import { ServicesSmp } from './Services';
import Testimonials from './Testimonials';
import Contact from './Contact';

interface PageProps { user: string | null; }

const SmpPage = ({ user }: PageProps) => (
  <Layout user={user}>
    <HeroSmp />
    <SmpOverview />
    <Clients />
    <ServicesSmp />
    <Testimonials />
    <Contact />
  </Layout>
);

export default SmpPage;
